import React from 'react';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { Row } from '../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../CommonComponents/OPL/Grid/Column';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import { yesNoOpts } from '../../AccountOpening.meta';
import { MarginProps } from '../../../../theme/styledProps';
import { Grid } from '../../../../CommonComponents/OPL/Grid/Grid';
import { Wrapper } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

const fieldName = 'isPoliticallyExposed';
const familyFieldName = 'immediateFamily';
const orgFieldName = 'politicalOrganization';

export const PoliticallyExposed: React.FC<MarginProps> = props => {
  const formBag = useFormContext();
  const {
    formState: { errors },
  } = formBag;

  const isPoliticallyExposed = formBag.watch(fieldName);

  return (
    <Wrapper {...props}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            value={yesNoOpts.find(({ value }) => value === field.value)}
            label="Are you or a member of your family a current or former high-level elected or appointed public official?"
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value);
              }
            }}
            options={yesNoOpts}
          />
        )}
      />

      {isPoliticallyExposed && (
        <Grid>
          <Row mt="8">
            <Column width={6}>
              <Input
                {...formBag.register(familyFieldName)}
                label="Legal Name"
                type="text"
                placeholder="Name"
                formVariant={get(errors, familyFieldName) ? 'error' : undefined}
                helperText={(get(errors, familyFieldName) as FieldError | undefined)?.message}
                maxLength={256}
              />
            </Column>

            <Column width={6}>
              <Input
                {...formBag.register(orgFieldName)}
                label="Political Organization"
                type="text"
                placeholder="Organization"
                formVariant={get(errors, orgFieldName) ? 'error' : undefined}
                helperText={(get(errors, orgFieldName) as FieldError | undefined)?.message}
                maxLength={256}
              />
            </Column>
          </Row>
        </Grid>
      )}
    </Wrapper>
  );
};
